import styles from './ColorSwatch.module.css';

export interface ColorSwatchProps {
  label: string;
  value: string;
  onChange: (hex: string) => void;
  className?: string;
}

export function ColorSwatch({
  label,
  value,
  onChange,
  className,
}: ColorSwatchProps) {
  return (
    <div
      data-crd-id="r2.bq-color-swatch"
      data-crd-layer="r2"
      className={`${styles.swatch} ${className ?? ''}`}
    >
      <span className={styles.label}>{label}</span>
      <div className={styles.pickerWrap}>
        <input
          type="color"
          className={styles.picker}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <code className={styles.hex}>{value}</code>
      </div>
    </div>
  );
}
